// お知らせのtype（種別）に関する定義

export const DEFAULT_NEWS_TYPE = 'その他';

export const NEWS_TYPES = [
  '重要',
  '休診',
  '診療時間',
  '診療案内',
  '予防接種・検診',
  '感染症情報',
  '医師',
  'その他',
];

// type毎のタグ表示色
const NEWS_TYPE_COLORS = {
  '重要': { background: '#ffe5e5', color: '#c62828', border: '#ffcdd2' },
  '休診': { background: '#fff3e0', color: '#ef6c00', border: '#ffe0b2' },
  '診療時間': { background: '#e3f2fd', color: '#1565c0', border: '#bbdefb' },
  '診療案内': { background: '#e8f5e9', color: '#2e7d32', border: '#c8e6c9' },
  '予防接種・検診': { background: '#f3e5f5', color: '#7b1fa2', border: '#e1bee7' },
  '感染症情報': { background: '#fce4ec', color: '#ad1457', border: '#f8bbd0' },
  '医師': { background: '#e0f2f1', color: '#00695c', border: '#b2dfdb' },
  'その他': { background: '#f5f5f5', color: '#616161', border: '#e0e0e0' },
};

export function getNewsTypeColor(type) {
  return NEWS_TYPE_COLORS[type] || NEWS_TYPE_COLORS[DEFAULT_NEWS_TYPE];
}
